import { render, staticRenderFns } from "./CodeItem.vue?vue&type=template&id=ea1e2fb8&scoped=true"
import script from "./CodeItem.vue?vue&type=script&lang=js"
export * from "./CodeItem.vue?vue&type=script&lang=js"
import style0 from "./CodeItem.vue?vue&type=style&index=0&id=ea1e2fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1e2fb8",
  null
  
)

export default component.exports